module.exports = __webpack_public_path__ + "img/money-check-pen.ce63095f.svg";